import React, { Fragment, useEffect, useState } from "react";
import { set_disputes } from "../../../redux/actions/DisputesAction";
import { set_loading } from "../../../redux/actions/LayoutAction";
import { connect } from "react-redux";
import { apiJson } from "../../../api/Api";
import { toast } from "react-toastify";
import Header from "../subheader/Header";
import TableList from "./TableList";
import "./disputes.scss";

const Disputes = (props) => {
  const [data, setData] = useState(false);
  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };
  const getDisputes = (page) =>
    apiJson.disputes.getDisputes(page).then((response) => {
      if (response.success) {
        props.set_disputes({
          disputes: response.data.disputes,
          pagination: response.data.pagination,
        });
        setData(true);
      } else if (!response.status) {
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
        setData(true);
      } else {
        setData(true);
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
            ? response.errors
            : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });

  const pageChange = (page) => {
    setData(false);
    getDisputes(page);
  };

  useEffect(() => {
    document.title = "Disputes";
  }, []);

  useEffect(() => {
    getDisputes(1);
    // eslint-disable-next-line
  }, []);

  // eslint-disable-next-line
  useEffect(() => props.set_loading(!data), [data]);
  return (
    <Fragment>
      <div className="vendor-page-right disputes-page-desktop">
        <Header heading="Disputes" search={false} filters={null} />
        {data && (
          <div className="right-content disputes-right-content">
            <div className="content-container disputes-content-container">
              <div className="content-wrapper">
                <TableList
                  List={props.disputes}
                  pageChange={pageChange}
                  pagination={props.pagination}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    pagination: state.dispute.pagination,
    disputes: state.dispute.disputes,
    load: state.layout.isLoading,
  };
};

const mapDispatchTopProps = { set_disputes, set_loading };

export default connect(mapStateToProps, mapDispatchTopProps)(Disputes);
